/*
 * Author M. Atoar Rahman
 * Title: D3 Report
 * Description: Index for D3 Report
 * Date: 05/06/2022
 */

import { Card } from 'react-bootstrap';
import { useD3Report } from './ContextAPI';
import FormInfo from './FormInfo';
import ShowModel from './ShowModel';

export default function Index() {
    const { show } = useD3Report();

    return show ? (
        <Card>
            <Card.Body>
                <ShowModel />
            </Card.Body>
        </Card>
    ) : (
        <FormInfo />
    );
}
